import React, { useState, useEffect, useRef, useContext } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Typography,
    Box,
    IconButton,
    InputAdornment,
    Divider
} from "@material-ui/core";
import {
    Visibility,
    VisibilityOff,
    Settings,
    Payment,
    Schedule as ScheduleIcon
} from "@material-ui/icons";
import {
    Switch,
    FormControlLabel,
    Chip,
    Stack
} from "@mui/material";
import { AuthContext } from "../../context/Auth/AuthContext";
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
    },
    multFieldLine: {
        display: "flex",
        "& > *:not(:last-child)": {
            marginRight: theme.spacing(1),
        },
    },
    btnWrapper: {
        position: "relative",
    },
    sectionTitle: {
        fontWeight: "bold",
        color: theme.palette.primary.main,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1)
    },
    restrictionBox: {
        backgroundColor: '#FFF5F5',
        border: '1px solid #FEB2B2',
        color: '#C53030',
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
    },
    compactTextField: {
        "& .MuiInputBase-input": {
            padding: "8px 4px",
        },
        "& .MuiInputAdornment-root": {
            margin: 0,
            "& p": {
                color: theme.palette.primary.main,
                fontWeight: "bold",
            }
        }
    }
}));
const ValidationSchema = Yup.object().shape({
    name: Yup.string().required("Requerido"),
    provider: Yup.string().required("Requerido"),
    apiKey: Yup.string(),
    model: Yup.string().required("Requerido"),
});
const FlowBuilderAddPaymentValidationModal = ({ open, onSave, data, onUpdate, close }) => {
    const classes = useStyles();
    const { user } = useContext(AuthContext);
    const [showApiKey, setShowApiKey] = useState(false);
    const [models, setModels] = useState([]);
    const [loadingModels, setLoadingModels] = useState(false);
            const isVisionEnabled = user?.company?.enableVision;
    const initialState = {
        name: "Validar Pago con IA",
        provider: "openai",
        apiKey: "",
        model: "gpt-4o-mini",
        varName: "{{pago_titular}}",
        varAmount: "{{monto_leido}}",
        varRef: "{{nro_operacion}}",
        varBank: "{{banco_pago}}",
        varDate: "{{fecha_pago}}",
        varTime: "{{hora_pago}}",
        successMessage: "",
        errorMessage: ""
    };
    const [integration, setIntegration] = useState(initialState);
    useEffect(() => {
        if (open === "edit" && data) {
            const savedData = data.data?.paymentValidation || data.data || {};
            setIntegration({
                ...initialState,
                ...savedData,
                varName: savedData.varName ? `{{${savedData.varName.replace(/[{}]/g, '')}}}` : initialState.varName,
                varAmount: savedData.varAmount ? `{{${savedData.varAmount.replace(/[{}]/g, '')}}}` : initialState.varAmount,
                varRef: savedData.varRef ? `{{${savedData.varRef.replace(/[{}]/g, '')}}}` : initialState.varRef,
                varBank: savedData.varBank ? `{{${savedData.varBank.replace(/[{}]/g, '')}}}` : initialState.varBank,
                varDate: savedData.varDate ? `{{${savedData.varDate.replace(/[{}]/g, '')}}}` : initialState.varDate,
                varTime: savedData.varTime ? `{{${savedData.varTime.replace(/[{}]/g, '')}}}` : initialState.varTime,
                successMessage: savedData.successMessage || initialState.successMessage,
                errorMessage: savedData.errorMessage || initialState.errorMessage,
            });
            if (savedData.model) setModels([savedData.model]);
                        // Remarketing removed
        } else {
            setIntegration(initialState);
        }
    }, [open, data]);
    const handleFetchModels = async (apiKey, provider) => {
        setLoadingModels(true);
        try {
            const { data } = await api.post("/openai/models", { apiKey, provider });
            // Filtrar por modelos conocidos con visión si es posible, o mostrar todos
            setModels(data);
            toast.success("Modelos cargados");
        } catch (err) {
            toast.error("Error al cargar modelos");
        }
        setLoadingModels(false);
    };
    const handleSave = (values) => {
        
        const finalValues = {
            ...values,
            
        };
        if (open === "edit") {
            onUpdate({
                ...data,
                data: finalValues,
            });
        } else {
            onSave(finalValues);
        }
        close();
    };
    return (
        <div className={classes.root}>
      <Dialog
        open={!!open}
        onClose={close}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
            <Box display="flex" alignItems="center" gap={1}>
                <Payment color="primary" /> {open === "edit" ? "Editar Reconocimiento de Pago" : "Agregar Reconocimiento de Pago"}
            </Box>
        </DialogTitle>
            <Formik
                initialValues={integration}
                enableReinitialize
                validationSchema={ValidationSchema}
                onSubmit={handleSave}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form style={{ display: 'flex', flexDirection: 'column' }}>
                        <DialogContent dividers>
                            {!isVisionEnabled && (
                                <div className={classes.restrictionBox}>
                                    <strong>⚠️ Bloqueado:</strong> Tu plan no tiene habilitado el reconocimiento de imágenes. Contacta a soporte.
                                </div>
                            )}
                            <Field
                                as={TextField}
                                label="Nombre del Nodo"
                                name="name"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                disabled={!isVisionEnabled}
                            />
                            {false && user?.super && (
                                <Field
                                    as={TextField}
                                    label="API Key"
                                    name="apiKey"
                                    type={showApiKey ? "text" : "password"}
                        autoComplete="new-password"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!isVisionEnabled}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={() => setShowApiKey(!showApiKey)}>
                                                    {showApiKey ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => handleFetchModels(values.apiKey, values.provider)}
                                                    disabled={!values.apiKey || loadingModels || !isVisionEnabled}
                                                >
                                                    Cargar
                                                </Button>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            )}
                            <Divider style={{ margin: '20px 0' }} />
                            <Typography className={classes.sectionTitle}><Settings fontSize="small" /> Variables Automáticas</Typography>
                            <div style={{
                                backgroundColor: "rgba(115, 103, 240, 0.05)",
                                borderRadius: "8px",
                                padding: "12px 16px",
                                marginTop: "8px",
                                marginBottom: "24px",
                                border: "1px solid rgba(255, 255, 255, 0.2)"
                            }}>
                                <Typography variant="subtitle2" style={{ fontWeight: "600", marginBottom: "8px" }}>
                                    Datos Extraídos por la IA
                                </Typography>
                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: "16px" }}>
                                    El nodo analizará el comprobante y guardará automáticamente la información en estas variables para que las uses en tus siguientes nodos (Texto o Condición):
                                </Typography>
                                
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', fontSize: '12.5px' }}>
                                    <div style={{ width: '48%', display: 'flex', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 'bold', color: '#A59BFC', width: '130px' }}>{"{{pago_titular}}"}</span>
                                        <span style={{ color: '#E2E8F0', opacity: 0.9, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Nombre del cliente</span>
                                    </div>
                                    <div style={{ width: '48%', display: 'flex', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 'bold', color: '#A59BFC', width: '130px' }}>{"{{monto_leido}}"}</span>
                                        <span style={{ color: '#E2E8F0', opacity: 0.9, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Importe</span>
                                    </div>
                                    <div style={{ width: '48%', display: 'flex', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 'bold', color: '#A59BFC', width: '130px' }}>{"{{nro_operacion}}"}</span>
                                        <span style={{ color: '#E2E8F0', opacity: 0.9, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Referencia u Operación</span>
                                    </div>
                                    <div style={{ width: '48%', display: 'flex', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 'bold', color: '#A59BFC', width: '130px' }}>{"{{banco_pago}}"}</span>
                                        <span style={{ color: '#E2E8F0', opacity: 0.9, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>App o Banco Origen</span>
                                    </div>
                                    <div style={{ width: '48%', display: 'flex', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 'bold', color: '#A59BFC', width: '130px' }}>{"{{fecha_pago}}"}</span>
                                        <span style={{ color: '#E2E8F0', opacity: 0.9, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Fecha del pago</span>
                                    </div>
                                    <div style={{ width: '48%', display: 'flex', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 'bold', color: '#A59BFC', width: '130px' }}>{"{{hora_pago}}"}</span>
                                        <span style={{ color: '#E2E8F0', opacity: 0.9, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Hora del pago</span>
                                    </div>
                                </div>
                            </div>
                            {/* Sección de Mensajes Opcionales */}
                            <div style={{
                                backgroundColor: "rgba(124, 58, 237, 0.05)",
                                borderRadius: 1,
                                padding: 2,
                                border: `1px solid rgba(124, 58, 237, 0.1)`,
                                marginTop: 2
                            }}>
                                <Typography variant="subtitle2" style={{ fontWeight: "600", marginBottom: "8px" }}>
                                    Mensajes Automáticos de Respuesta (Opcional)
                                </Typography>
                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: "16px" }}>
                                    Si configuras estos mensajes, el nodo responderá automáticamente. Si los dejas en blanco, el flujo avanzará silenciosamente (ideal si conectas a un nodo "Condición").
                                </Typography>
                                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                    <div>
                                        <Field
                                            as={TextField}
                                            name="successMessage"
                                            label="Mensaje de Éxito"
                                            fullWidth
                                            multiline
                                            minRows={7}
                                            variant="outlined"
                                            helperText="Ej: ✅ He confirmado tu Comprobante. Titular: {{pago_titular}}"
                                        />
                                    </div>
                                    <div>
                                        <Field
                                            as={TextField}
                                            name="errorMessage"
                                            label="Mensaje de Error"
                                            fullWidth
                                            multiline
                                            minRows={5}
                                            variant="outlined"
                                            helperText="Ej: ❌ Tu comprobante no es válido o es ilegible."
                                        />
                                    </div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => close(null)} variant="outlined" style={{ borderColor: "#ff4d4f", color: "#ff4d4f", textTransform: "none", fontWeight: "bold", borderRadius: "8px" }}>
                                {i18n.t("common.cancel") || "Cancelar"}
                            </Button>
                            <Button type="submit" disabled={!isVisionEnabled} variant="contained" style={{ backgroundColor: "#7367F0", color: "#fff", textTransform: "none", fontWeight: "bold", borderRadius: "8px", boxShadow: "0 4px 14px 0 rgba(115, 103, 240, 0.39)", marginLeft: "8px" }}>
                                {open === "edit" ? (i18n.t("common.save") || "Guardar") : (i18n.t("common.add") || "Agregar")}
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
      </Dialog>
    </div>
    );
};
export default FlowBuilderAddPaymentValidationModal;
